import client from '../httpClient';

const stationsApi = (railwayId) => {
  const GET_STATIONS_URL = `/common/stations/${railwayId}`;
  return client.get(GET_STATIONS_URL, String(railwayId));
};

export default stationsApi;
